import { useState } from "react";
import { QRCodeSVG } from "qrcode.react";
import { IMAGES, CONTENT } from "../../const/config";
import { trackDownload, trackGuide, trackInstallFlow } from '../../analytics/tracking';
import InstallGuideModal from "./InstallGuideModal";

export default function PlatformDownload({ icon, title, directLink, storeLink, compact = false }) {
  const [tab, setTab] = useState("store");
  const [showGuide, setShowGuide] = useState(false);

  const isDirect = tab === "direct";
  const isAndroid = title === "Android";
  const platformKey = isAndroid ? "android" : "ios";

  const handleTabSwitch = (t) => {
    setTab(t);
    trackInstallFlow(platformKey, "switch_tab", t);
  };

  const handleDownloadClick = () => {
    trackDownload(platformKey, tab);
  };

  const handleInstallGuideClick = (e) => {
    e.preventDefault();
    trackGuide(platformKey);
    setShowGuide(true);
  };

  const renderDownloadBadge = () => {
    const config = isDirect
      ? isAndroid
        ? { src: IMAGES.apkFile, alt: "APK", label: "Download by", name: "APK" }
        : { src: IMAGES.testFlight, alt: "TestFlight", label: "Download on", name: "TestFlight" }
      : isAndroid
        ? { src: IMAGES.googlePlay, alt: "Google Play", label: "Tải ngay", name: "Google Play" }
        : { src: IMAGES.appStore, alt: "App Store", label: "Tải ngay", name: "App Store" };

    return (
      <div className="flex items-center gap-2 w-44 py-2 px-3 rounded-s bg-blue-600 shadow-lg">
        <img src={config.src} className="w-8 h-8 object-contain" alt={config.alt} />
        <div className="flex flex-col leading-tight text-left">
          <span className="text-[10px] font-semibold text-white uppercase tracking-wide">
            {config.label}
          </span>
          <span className="text-xs font-semibold text-white">{config.name}</span>
        </div>
      </div>
    );
  };

  return (
    <div className={`flex flex-col items-center ${compact ? "gap-2" : "gap-3"}`}>
      <div className="flex items-center gap-1.5 text-gray-700 font-semibold text-sm">
        {icon}
        <span>{title}</span>
      </div>

      <div className="flex gap-1 bg-gray-100 rounded-full p-0.5">
        {["store", "direct"].map((t) => (
          <button
            key={t}
            onClick={() => handleTabSwitch(t)}
            className={`px-3 py-1 text-xs font-medium rounded-full transition-all duration-200 ${
              tab === t ? "bg-blue-600 text-white shadow-sm" : "text-gray-500 hover:text-gray-700"
            }`}
          >
            {t === "direct"
              ? (isAndroid ? CONTENT.labels.apkVersion : CONTENT.labels.testFlight)
              : isAndroid ? "Google Play" : "App Store"}
          </button>
        ))}
      </div>

      <div className="flex items-center gap-3">
        <div
          className={`rounded-lg flex-shrink-0 bg-white flex items-center justify-center p-1 ${compact ? "w-20 h-20" : "w-24 h-24"}`}
        >
          {(isDirect ? directLink : storeLink) ? (
            <QRCodeSVG
              value={isDirect ? directLink : storeLink}
              size={88}
              level="M"
              aria-label={`${title} QR`}
            />
          ) : (
            <div
              className="w-8 h-8 border-4 border-gray-200 border-t-blue-600 rounded-full animate-spin"
              role="status"
              aria-label="Đang tải QR"
            />
          )}
        </div>
        <div className={compact ? undefined : "flex flex-col items-center gap-2"}>
          <a
            href={isDirect ? directLink : storeLink}
            target="_blank"
            rel="noreferrer"
            className="block hover:opacity-80 transition-opacity"
            onClick={handleDownloadClick}
          >
            {renderDownloadBadge()}
          </a>
        </div>
        {compact && (
          <button
            onClick={handleInstallGuideClick}
            className={`transition-colors ${isDirect ? "text-red-600 hover:text-blue-800" : "invisible"}`}
            title="Hướng dẫn cài đặt"
          >
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
              <circle cx="12" cy="12" r="10" />
              <line x1="12" y1="16" x2="12" y2="12" />
              <line x1="12" y1="8" x2="12.01" y2="8" />
            </svg>
          </button>
        )}
      </div>

      {!compact && (
        <button
          className={`flex items-center justify-center gap-1.5 w-full px-4 py-2 bg-blue-600 text-white text-xs font-semibold rounded-md hover:bg-blue-700 transition-colors ${
            isDirect ? "visible" : "invisible"
          }`}
          onClick={handleInstallGuideClick}
        >
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
            <circle cx="12" cy="12" r="10" />
            <line x1="12" y1="16" x2="12" y2="12" />
            <line x1="12" y1="8" x2="12.01" y2="8" />
          </svg>
          Hướng dẫn cài đặt
        </button>
      )}

      {showGuide && (
        <InstallGuideModal
          platform={platformKey}
          onClose={() => setShowGuide(false)}
        />
      )}
    </div>
  );
}